module.exports = __webpack_public_path__ + "static/media/home-balcony.184b0148.jpg";